import { AxiosRequestConfig, AxiosInstance } from 'axios';
import { errorHandlingInterceptor } from '../helpers/error';
import { getAxiosClientWithRefreshToken } from './axiosWithRefreshToken';

/**
 * Creates a new instance of axios with a custom config
 *
 * @type {AxiosInstance} client
 */

const client = getAxiosClientWithRefreshToken({
  baseURL: `${process.env.NX_PUBLIC_CMS_HOST}/api`,
  authHeaderName: 'Clatter-Authorization',
});

client.interceptors.response.use(
  (response) => response,
  errorHandlingInterceptor,
);

/**
 * Axios instance that uses auth0 access token
 *
 * @param {AxiosRequestConfig} requestConfigOptions
 * @returns {Promise}
 */
const getAxiosCmsWithAuthorization = (requestConfigOptions) => {
  const onSuccess = (response) => {
    return Promise.resolve(response);
  };

  return client({
    ...(requestConfigOptions || {}),
    headers: {
      ...(requestConfigOptions?.headers || {}),
      'Strapi-Response-Format': 'v4', // use Strapi's legacy v4 response formats instead of v5 ones
    },
  }).then(onSuccess);
};

export default getAxiosCmsWithAuthorization;
